import React, { useEffect } from 'react'
import PageContent from '../../components/PageContent/PageContent'
import CustomTitle from '../../components/UI/title/CustomTitle'
import ProofTemplateContent from './ProofTemplateContent'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setButtonClick, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import { setIsShowButtonNot } from '../../store/buttonNotSlice';
import useMixpanel from '../../hooks/useMixpanel';

export default function ProofTemplate({title, text, img, eventName}) {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Continue'));
        dispatch(setIconButton(''));

        dispatch(setIsShowButtonNot(false));
    }, []);
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    const {trackP1Event} = useMixpanel();
    useEffect(() => {
        if (buttonClicked) {
            dispatch(setButtonClick(false));
            trackP1Event(eventName, {})
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonClicked, dispatch]);

    return (

        <div className="page">
            <PageContent>
                <div className="page-content">
                    <CustomTitle
                        style={{ marginBottom: '12rem' }}
                        title={title}
                    />
                    <p className="text" style={{ marginBottom: '24rem' }}>{text}</p>
                    <ProofTemplateContent img={img}/>
                </div>

            </PageContent>

        </div>
    )
}
